/* @flow */
import * as React from 'react';

import styles from './ActionDrawerTable.module.scss';

const ActionDrawerTable: React.StatelessFunctionalComponent<*> = ({ data }: Array<Array>) => {
  let spacer: string;

  return (
    <div className={styles['action-drawer-table']}>
      <table>
        <tbody>
          {data.map((item: Array<string>, index: number) => {
            if (item.length === 0) {
              spacer = index;
            }

            const spacerClass: string = index === spacer + 1 ? styles['spacer-row'] : null;

            return item.length ? (
              <tr key={index.toString()} className={spacerClass}>
                {item.map((str: string, i: number) => (
                  <td key={i.toString()}>{i === 0 ? <b>{`${str}:`}</b> : str}</td>
                ))}
              </tr>
            ) : null;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ActionDrawerTable;
